import KformComponent from '../kform-component';
import { projections } from '~/components/input-geo/input-geo.controller';
import Card from '~/scripts/services/model/card';

export default class GeoComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentGeo | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.availableProjections = settings?.availableProjections ?? projections.map(p => p.id),
		this.conditional = settings?.conditional ?? {
			eq: '',
			show: undefined,
			when: undefined,
		};
		this.defaultValue = settings?.defaultValue ?? false;
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = true;
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.projection = settings?.projection ?? 'WGS84';
		this.showCurrentPositionButton = settings?.showCurrentPositionButton ?? true;
		this.showMap = settings?.showMap ?? false;
		this.showMapButton = settings?.showMapButton ?? true;
		this.showProjectionSelection = settings?.showProjectionSelection ?? true;
		this.tableView = settings?.tableView ?? true;
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'p',
			'c',
		]);
	}
}
